// extracted by mini-css-extract-plugin
module.exports = {"arrow":"_103a151b99--arrow--GIavW"};